import { setSearchValueAction as setSearchValueOperation } from 'editor/src/store/editorModules/addons/slice';

export default setSearchValueOperation;
